<template>
  <div class="w-100">
    <!-- <a class="block__absolute block__absolute--auto" @click="$emit('backClickedFromRegister')">Back</a> -->

    <div class="card-header bg-transparent pb-4 border-0">
      <div class="logo-center text-center mb-4 pb-4 border-bottom">
       <logo />
      </div>
                        
      <form role="form">
        <base-input
          v-model="code"
          alternative
          class="mb-3"
          prepend-icon="ni ni-email-83"
          placeholder="Enter Verification code"
        />
        <div 
          v-if="$v.code.$error" 
          class="error field">Valid verification code is required</div>
                
                    
        <div class="text-center">
          <base-button 
            type="primary" 
            class="my-4 btn-block" 
            @click="handleRegistration">Verify</base-button>
        </div>
      </form>

    </div>

  </div>
</template>
<script>
import Logo from './Logo.vue';
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import { required, minLength, between, email, sameAs } from 'vuelidate/lib/validators'
export default {
  components: { Logo },
    name: "Verify",
    data() {
        return {
            code: "",
        }
    },
    validations: {
        code: {
            required
        }
    },
    computed: {
        ...mapState('user',['registrationData']),
        usersDataAsString () {
            return JSON.stringify(this.registrationData)
        }
    },
   
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('user', ['performUserVerification']),
        handleRegistration() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                //return
            }

            // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
            //    this.$router.push('/projects')
            // }).catch(err => {
            //     this.$snack.success('Invalid Credentials.')
            // })
            this.setLoading(true)
            this.performUserVerification(
                {
                    verification_code: this.code,
                    email: this.registrationData.email
                }
            ).then(r => {
                this.setLoading(false)
                this.$emit('userVerified')

            }).catch(e => {
                if(e.response.status == 400) {
                    this.$snack.success(e.response.data.message)
                }
                
                this.setLoading(false)
            })
        }
    }
}
</script>

<style lang="sass">

</style>